module.exports = __webpack_public_path__ + "videos/whatsnew-selectioncolorfill_cn.2d5259c.mp4";